module.exports = __webpack_public_path__ + "media/images/emblems/Walterswil-coat_of_arms-0735d14d32a0cbf31d55b6e0621bb943.svg";